import React, { useEffect } from "react";

import "./styles.css";

const PrintPage = ({ children, className }) => {
  useEffect(() => {
    setTimeout(() => window.print(), 500);
  });

  return (
    <div className={className ? "" : "bg"}>
      <div className={className ? className : "page"}>{children}</div>
    </div>
  );
};

export default PrintPage;
